
import React, { Component } from 'react';
import { Heading } from 'grommet';

import BackLink from './BackLink';
import Page from './Page';
import TratList from '../components/TratList';
import ObjectList from './ObjectList';

class TratListPage extends Component {

    componentDidMount() {
        if (!this.props.tratList.initialized) {
            this.props.getTratList();
        }
    }

    handleFilterChange = (attributeId, attributeValue) => {
        this.props.setFilter(attributeId, attributeValue);
    }

    render() {
        return (
            <Page>
                <Heading level={1} color="titleColor">Seznam současných viničních tratí</Heading>
                <ObjectList objectList={this.props.tratList}>
                    <TratList
                        countAll={(this.props.tratList.data && this.props.tratList.data.items) ? this.props.tratList.data.items.length : 0}
                        tratList={this.props.filteredTratList}
                        tratOdrudaList={this.props.tratList.data.odrudy}
                        tratFilter={this.props.tratFilter}
                        onFilterChange={this.handleFilterChange}
                        setMapPoints={this.props.setMapPoints}
                    />
                </ObjectList>

                <BackLink link="/" title="Zpět na úvod"/>
            </Page>
        );
    }
}

export default TratListPage;
